"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionType = exports.TransactionList = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Button = require("../Button");
var _Popup = require("../Popup");
var _ic_cbot_topup = _interopRequireDefault(require("../../assets/images/ic_cbot_topup.png"));
var _ic_cbot_withdrawID = _interopRequireDefault(require("../../assets/images/ic_cbot_withdrawID.png"));
var _cb_ic_withdraw = _interopRequireDefault(require("../../assets/images/cb_ic_withdraw.png"));
var _cb_ic_topup = _interopRequireDefault(require("../../assets/images/cb_ic_topup.png"));
var _Transaction = require("../Transaction");
var _OtherMoreTransactionList = require("./OtherMoreTransactionList");
var _LocaleProvider = require("../LocaleProvider");
var _constants = require("../../utils/constants");
var _useTracking = require("../../hooks/useTracking");
var _context = require("../ConfigProvider/context");
var _elementScrollTrack = require("../../utils/tracking/elementScrollTrack");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var TransactionType;
exports.TransactionType = TransactionType;
(function (TransactionType) {
  TransactionType[TransactionType["Topup"] = 2] = "Topup";
  TransactionType[TransactionType["Withdrawal"] = 3] = "Withdrawal";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var TransactionList = function TransactionList(props) {
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showTime = _useState2[0],
    setShowTime = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    showPopup = _useState4[0],
    setShowPopup = _useState4[1];
  var containerRef = (0, _react.useRef)(null);
  var hasMoreTransaction = props.hasMoreTransaction,
    _props$content = props.content,
    content = _props$content === void 0 ? [] : _props$content,
    loadMoreTransactionText = props.loadMoreTransactionText,
    selectTransactionText = props.selectTransactionText,
    type = props.type,
    action = props.action,
    onLoadMore = props.onLoadMore,
    _props$maxDisplay = props.maxDisplay,
    maxDisplay = _props$maxDisplay === void 0 ? 5 : _props$maxDisplay,
    panelTitleText = props.panelTitleText,
    _onTransactionCardClick = props.onTransactionCardClick,
    componentTrackingData = props.componentTrackingData;
  var elementScrollTrack = new _elementScrollTrack.ElementScrollTrackManage();
  var _useComponentTracking = (0, _useTracking.useComponentTracking)(props),
    tracker = _useComponentTracking.tracker,
    result = _useComponentTracking.result;
  var moreTransactionTracking = result.moreTransaction,
    donNotSeeTransactionTracking = result.donNotSeeTransaction,
    transactionListTrackData = result.transactionList,
    closePanelTrackingData = result.closePanel;
  var trackingData = componentTrackingData && {
    panelDoNotSeeTransaction: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.panelDoNotSeeTransaction,
    panelTransaction: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.panelTransaction
  };
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var title = panelTitleText ? panelTitleText : type === TransactionType.Withdrawal ? trans(_constants.LABEL_WITHDRAWAL) : trans(_constants.LABEL_TOPUP);
  var image = type === TransactionType.Topup ? _cb_ic_topup.default : _cb_ic_withdraw.default;
  var handleMoreOrderClick = function handleMoreOrderClick() {
    (moreTransactionTracking === null || moreTransactionTracking === void 0 ? void 0 : moreTransactionTracking.trackingClick) && tracker.click(moreTransactionTracking.trackingClick);
    setShowPopup(true);
  };
  var renderTransactionItem = function renderTransactionItem(props) {
    var _transaction$action;
    var transaction = props.transaction,
      index = props.index;
    if (transaction !== null && transaction !== void 0 && (_transaction$action = transaction.action) !== null && _transaction$action !== void 0 && _transaction$action.info) {
      transaction.action.info.image = image;
    }
    var _useComponentTracking2 = (0, _useTracking.useComponentTracking)({
        // @ts-ignore
        componentTrackingData: {
          transaction: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.transaction
        },
        componentData: {
          transaction: transaction,
          index: index
        }
      }),
      tracker = _useComponentTracking2.tracker,
      transactionTracking = _useComponentTracking2.result.transaction;
    var handleCardClick = function handleCardClick() {
      (transactionTracking === null || transactionTracking === void 0 ? void 0 : transactionTracking.trackingClick) && tracker.click(transactionTracking.trackingClick);
    };
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _getPrefixCls.getPrefixCls)('transaction-list-item'),
      key: "transaction-".concat(index),
      onClick: handleCardClick
    }, transactionTracking === null || transactionTracking === void 0 ? void 0 : transactionTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement(_Transaction.Transaction, (0, _extends2.default)({}, transaction, {
      image: image
    })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
      action: transaction.action,
      text: selectTransactionText,
      className: (0, _getPrefixCls.getPrefixCls)('transaction-list-item-button')
    }));
  };
  var handleNoMoreTransactionClick = function handleNoMoreTransactionClick() {
    (donNotSeeTransactionTracking === null || donNotSeeTransactionTracking === void 0 ? void 0 : donNotSeeTransactionTracking.trackingClick) && tracker.click(donNotSeeTransactionTracking.trackingClick);
    console.log('handleNoMoreTransactionClick', handleNoMoreTransactionClick);
  }; // const renderNoMoreBtn = () => {
  //   const { noMoreText } = props;
  //   return (
  //     <div className={getPrefixCls('transaction-list-more-btn')} onClick={handleNoMoreTransactionClick} {...donNotSeeTransactionTracking?.trackingImpressionProps}>
  //       <div className={getPrefixCls('transaction-list-more-btn-container')}>
  //         <span>{noMoreText}</span>
  //       </div>
  //     </div>
  //   );
  // };

  var renderHasMoreBtn = function renderHasMoreBtn(props) {
    var loadMoreTransactionText = props.loadMoreTransactionText,
      type = props.type;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _getPrefixCls.getPrefixCls)('transaction-list-more-btn'),
      onClick: function onClick() {
        return handleMoreOrderClick();
      }
    }, moreTransactionTracking === null || moreTransactionTracking === void 0 ? void 0 : moreTransactionTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('transaction-list-more-btn-container')
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: type === TransactionType.Topup ? _ic_cbot_topup.default : _ic_cbot_withdrawID.default
    }), /*#__PURE__*/_react.default.createElement("span", null, loadMoreTransactionText)));
  };
  var renderStillNotSee = function renderStillNotSee(props) {
    var _useComponentTracking3 = (0, _useTracking.useComponentTracking)({
        componentTrackingData: componentTrackingData
      }),
      tracker = _useComponentTracking3.tracker,
      donNotSeeTransactionTracking = _useComponentTracking3.result.donNotSeeTransaction;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _getPrefixCls.getPrefixCls)('transaction-list-check_here'),
      onClick: function onClick() {
        var _context$eventEmitter, _props$checkHereActio;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : _context$eventEmitter.emit('next', {
          text: props === null || props === void 0 ? void 0 : props.checkHereContent,
          action: _objectSpread(_objectSpread({}, props.checkHereAction), {}, {
            _actualText_: props === null || props === void 0 ? void 0 : props.checkHereContent,
            nextParams: _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$checkHereActio = props.checkHereAction) === null || _props$checkHereActio === void 0 ? void 0 : _props$checkHereActio.nextParams), {}, {
              message_text: props === null || props === void 0 ? void 0 : props.checkHereContent
            })
          })
        });
        (donNotSeeTransactionTracking === null || donNotSeeTransactionTracking === void 0 ? void 0 : donNotSeeTransactionTracking.trackingClick) && tracker.click(donNotSeeTransactionTracking === null || donNotSeeTransactionTracking === void 0 ? void 0 : donNotSeeTransactionTracking.trackingClick);
      }
    }, donNotSeeTransactionTracking === null || donNotSeeTransactionTracking === void 0 ? void 0 : donNotSeeTransactionTracking.trackingImpressionProps), props.transactionContent, /*#__PURE__*/_react.default.createElement("span", {
      className: "click_text"
    }, props.checkHereContent));
  };
  var transactionScrollTrackHandler = function transactionScrollTrackHandler() {
    console.log('触发滚动上报', transactionListTrackData === null || transactionListTrackData === void 0 ? void 0 : transactionListTrackData.trackingScroll, transactionListTrackData);
    if (transactionListTrackData !== null && transactionListTrackData !== void 0 && transactionListTrackData.trackingScroll) {
      tracker.scroll(transactionListTrackData.trackingScroll);
    }
  };
  var addScrollTrackEvent = function addScrollTrackEvent() {
    if (containerRef.current) {
      elementScrollTrack.addTrack(containerRef.current, _elementScrollTrack.ScrollType.Horizontal, {
        scrollCallback: transactionScrollTrackHandler,
        containerElement: containerRef.current
      });
    }
  };
  (0, _react.useEffect)(function () {
    addScrollTrackEvent();
    return function () {
      elementScrollTrack.removeAllTrack();
    };
  }, [transactionListTrackData]);
  (0, _react.useEffect)(function () {
    if (showPopup) {
      setShowTime(Date.now());
      return;
    }
    if (!showPopup && showTime && closePanelTrackingData !== null && closePanelTrackingData !== void 0 && closePanelTrackingData.trackingClick) {
      var _closePanelTrackingDa;
      var _trackingData = _objectSpread(_objectSpread({}, (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : (_closePanelTrackingDa = closePanelTrackingData.trackingClick) === null || _closePanelTrackingDa === void 0 ? void 0 : _closePanelTrackingDa.data) || {}), {}, {
        view_duration: Math.floor((Date.now() - showTime) / 1000)
      });
      tracker.click(_objectSpread(_objectSpread({}, closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick), {}, {
        data: _trackingData
      }));
      setShowTime(0);
    }
  }, [showPopup]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: title,
    showCloseIcon: true,
    active: showPopup,
    onClose: function onClose() {
      return setShowPopup(false);
    },
    titleClassName: (0, _getPrefixCls.getPrefixCls)('transaction-list-popup-title'),
    contentClassName: (0, _getPrefixCls.getPrefixCls)('transaction-list-popup-content')
  }, /*#__PURE__*/_react.default.createElement(_OtherMoreTransactionList.OtherMoreTransactionList, {
    type: type,
    loadMoreFn: onLoadMore,
    selectTransactionText: selectTransactionText,
    action: action,
    onTransactionCardClick: function onTransactionCardClick(params) {
      setShowPopup(false);
      _onTransactionCardClick === null || _onTransactionCardClick === void 0 ? void 0 : _onTransactionCardClick(params);
    },
    componentTrackingData: trackingData,
    stillNotFoundContent: props === null || props === void 0 ? void 0 : props.stillNotFoundContent,
    checkHereAction: props === null || props === void 0 ? void 0 : props.checkHereAction,
    onClose: function onClose() {
      return setShowPopup(false);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('transaction-list-container'), 'chatbot-transaction-list-container'),
    ref: containerRef
  }, content.map(function (transaction, index) {
    return index < maxDisplay && renderTransactionItem({
      transaction: transaction,
      index: index
    });
  }), hasMoreTransaction && renderHasMoreBtn({
    loadMoreTransactionText: loadMoreTransactionText,
    type: type
  })), content.length >= 1 && renderStillNotSee({
    transactionContent: props.transactionContent,
    checkHereContent: props === null || props === void 0 ? void 0 : props.checkHereContent,
    checkHereAction: props === null || props === void 0 ? void 0 : props.checkHereAction
  }));
};
exports.TransactionList = TransactionList;